// Setores da Receita Bruta da DRE (dre.receitas.areas) — rótulo para a tela.
//
// `sem_setor` (03/10/2026): o que o rateio das parcelas não cobriu. Antes essa
// parte sumia da receita (que é a soma dos setores) e continuava pagando
// imposto; agora vira linha própria, que a tela destaca para alguém
// classificar. Só existe de 2026/Q2 em diante — trimestre fechado não muda.
export const ROTULO_AREA_RECEITA: Record<string, string> = {
  topografia: 'Topografia',
  hidrometria: 'Hidrometria',
  consultoria: 'Consultoria Ambiental',
  projeto: 'Projeto',
  fiscalizacao: 'Fiscalização de Projeto',
  segbarr: 'Segurança de Barragens',
  sem_setor: 'Sem setor (classificar)',
};

export function rotuloAreaReceita(chave: string): string {
  return ROTULO_AREA_RECEITA[chave] || (chave.charAt(0).toUpperCase() + chave.slice(1));
}

// Setor aparece quando tem receita. "Sem setor" aparece também NEGATIVO
// (rateio acima de 100% devolve a diferença), senão o total não fecha na tela,
// e aparece quando há item sem setor mesmo que a soma dê zero (uma parcela de
// 120% e outra sem setor se anulam — e a sem setor continuaria escondida).
export function mostrarAreaReceita(chave: string, valor: number, itensSemSetor = 0): boolean {
  if (chave === 'sem_setor') return Math.abs(valor) >= 0.01 || itensSemSetor > 0;
  return valor > 0;
}
